module.exports = __webpack_public_path__ + "static/media/sent-note.e5104561.svg";